import React, { useContext } from 'react';
import { PopularFacetsFragment } from 'src/types';
import { AppContext } from '@prisjakt/ui-app-context';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import { ExpandableGrid } from 'src/components/expandable-grid';
import { ProductGridCard } from 'src/components/product-card-new';
import { TitleMediumText, FontColor } from '@prisjakt/ui/text/variants';
import { InternalLink } from './styles';
import { useViewportContext } from 'src/components/viewport/context';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = PopularFacetsFragment['popularFacets'][0];

export const PopularFacetsSection: React.FC<Props> = ({
  title,
  url,
  products,
  linkText,
}) => {
  const { t } = useContext(AppContext);
  const { isTablet } = useViewportContext();

  return (
    <Panel>
      <PanelHeader style={{ flexWrap: 'wrap' }}>
        <PanelTitle>{title}</PanelTitle>
        <InternalLink
          to={url}
          onClick={() => {
            trackInternalNavigationClick({
              scope: InternalNavigationScope.POPULAR_FACETS_HEADER,
              nextPage: url,
            });
          }}
        >
          <TitleMediumText color={FontColor.PRIMARY}>
            {linkText}
          </TitleMediumText>
        </InternalLink>
      </PanelHeader>

      <ExpandableGrid
        limit={isTablet ? 3 : 4}
        expandText={t('common', 'button.show-more')}
        collapseText={t('common', 'button.show-less')}
        cssGrid
        items={products.map((product, index) => (
          <ProductGridCard
            key={product.id}
            imageSrc={product.media.first}
            shouldLazyLoadImage
            link={product.pathName}
            name={product.name}
            price={
              product.priceSummary.regular || product.priceSummary.alternative
            }
            rating={product.userReviewSummary.rating}
            reviewsCount={product.userReviewSummary.count}
            onClick={() => {
              trackInternalNavigationClick({
                scope: InternalNavigationScope.POPULAR_FACETS_PRODUCT_CARD,
                nextPage: product.pathName,
                index,
              });
            }}
          />
        ))}
      />
    </Panel>
  );
};
